import { render } from "./login-with-new-phone.vue?vue&type=template&id=7209a6dc&scoped=true"
import script from "./login-with-new-phone.vue?vue&type=script&lang=js"
export * from "./login-with-new-phone.vue?vue&type=script&lang=js"

import "./login-with-new-phone.vue?vue&type=style&index=0&id=7209a6dc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7209a6dc"]])

export default __exports__